export default "__VITE_ASSET__DxemsSdc__"